<template>
  <b-modal size="xl" scrollable v-model="show" centered :title="'Sachbearbeiter wählen'">
    <b-row>
      <b-col md="4">
        <b-form-input type="search" v-model="search" placeholder="Suchen" debounce="200" style="margin-bottom: 6px"></b-form-input>
      </b-col>
      <b-col><b-button variant="primary" class="" @click="$emit('add-sach'); show = false">Neuer Sachbearbeiter</b-button></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table id="my-table" :items="remainingSachs"
                 striped hover selectable
                 :fields="fields"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelected">
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                style="min-width: 100px"
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SelectSachDialog",

  props:{
    sachs: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      search: '',
      sortBy: 'name',
      sortDesc: false,
      show: false,
      selected: [],
      fields: [
        {key: "name", label: 'Name', sortable: true},
        {key: "office", label: 'Amt', sortable: true},
        {key: "access", label: 'Schlüsselfeld', sortable: true},
        {key: "department", label: 'Abteilung', sortable: true},
        {key: "phone", label: 'Telefon', sortable: true},
        {key: "room", label: 'Raum', sortable: true},
        {key: "file_number", label: 'Aktenzeichen', sortable: true},
        //{key: "fax", label: 'Fax', sortable: true},
        {key: "email", label: 'Email', sortable: true},
      ],

    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0;
    },
    remainingSachs: function () {
      let res = [];
      const filterText = this.search.trim().toLowerCase();
      if (filterText === "") {
        return this.sachs;
      }
      for (let i = 0; i < this.sachs.length; i++) {
        if (
            this.sachs[i].name.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].office.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].access.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].department.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].phone.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].room.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].file_number.toLowerCase().indexOf(filterText) > -1
            || this.sachs[i].email.toLowerCase().indexOf(filterText) > -1
        ) {
          res.push(this.sachs[i]);
        }
      }
      return res;
    }
  },
  methods: {
    rowSelected(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    onSave() {
      this.show = false;
      this.$emit("set-sach", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.selected = [];
      this.search = '';
      this.show = true;
    },
    getReturnData: function () {
      return this.selected[0];
    },
  }
}
</script>

<style scoped>
.b-select-item {
  height: 1.75rem;
  width: 1.75rem;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  color: #696969;
  text-align: center;
  line-height: 1.5rem;
  vertical-align: middle;
  margin-top: 1px;
}
.b-heading {
  line-height: 1.45;
  margin-bottom: 0;
  padding-left: 12px
}
.b-description {
  padding-left: 4.375rem;
}
</style>
